import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<circle cx="10" cy="16" r="4"/><circle cx="22" cy="26" r="4"/><circle cx="22" cy="6" r="4"/><path d="M12.63 13a4.1 4.1 0 011.13 1.67l6.15-5.27A4 4 0 0118.53 8zM18.24 24.67A4.1 4.1 0 0119.37 23l-5.9-5a4 4 0 01-1.39 1.45l6.15 5.27z"/>';
export var AndroidShareSVG = function AndroidShareSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
AndroidShareSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(AndroidShareSVG);